module.exports = __webpack_public_path__ + "img/icon_list_HDpic_26@2x.8b94b789.png";